export default __webpack_public_path__ + "static/media/ic_bybit.2cc19c99.svg";